import React, { useState, useEffect, useRef } from 'react'
import XLSX from "xlsx"
import { FiUpload } from 'react-icons/fi'
import MySweetAlert from '../Shared/MySweetAlert'

const ImportExcel = (props) => {

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [file, setFile] = useState([])
  const [confirmShow, setConfirmShow] = useState(false)
  const fileInput = useRef()


  const handleFile = (file /*:File*/) => {

    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = e => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        header: 1
      });

      /* Update state */
      setData(data);
      props.onChange(data)
      if (fileInput && fileInput.current) {
        fileInput.current.value = ""
      }
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  }

  const uploadAndSave = () => {

    setConfirmShow(false)

    handleFile(file)

  }

  const cancelUpload = () => {

    setConfirmShow(false);

    fileInput.current.value = ""

  }

  return (
    <>
      <React.Fragment>
      <MySweetAlert
        show={confirmShow}
        onCancel={() => cancelUpload()}
        onConfirm={() => uploadAndSave()}
        title="آیا از آپلود فایل اکسل مطمئن هستید؟"
        text="با آپلود فایل اکسل، تمامی محصولات داخل آن به محصولات سیستم اضافه خواهند شد"
        type="info"
      >
      </MySweetAlert>

        <input ref={fileInput} className="import-file" type="file" onChange={(e) => { setFile(e.target.files[0]); setConfirmShow(true) }} />
        <a className="btn btn-info btn-sm pull-left" onClick={() => fileInput.current.click()} style={{ margin: 0 }}>
          <FiUpload size="20px" style={{ verticalAlign: 'middle' }} />&nbsp;ورود از اکسل
        </a>


      </React.Fragment>
    </>
  )
}

export default ImportExcel;